<template>
  <b-row>
    <!-- Columna 1 -->
    <b-col cols="12" md="6">
      <b-row class="mb-1 justify-content-center text-center">
        <b-col class="py-2 col-6">
          <b-img class="img-bm" :src="require('@/assets/images/pdf/logo_new.png')"/>
        </b-col>
        <b-col class="col-6 p-2 d-flex flex-column align-items-center">
          <b-avatar
              :src="avatar"
              class="p-0"
              size="14rem"
            />
              <b-avatar class="icon-network" variant="ligth">
                <b-img :src="getIconWhitePng('instagram')" :class="getIconColor('instagram')" fluid/>
              </b-avatar>
            <h2 class="text-capitalize text-underline">{{ data.basic.title }}</h2>
            <p class="text-muted-left-side-analytics">{{ getFormat(data.metrics.subscribers_count.value)}} {{ $t('search_preview.totalAudience') }}</p>
            <p class="text-muted-left-side-analytics mb-1" v-if="data.features && data.features.blogger_geo && data.features.blogger_geo.data">{{ data.features.blogger_geo.data.country }}</p>
         </b-col>

      </b-row>
      <b-row>
        <b-col>
          <!-- Engagement Graph -->
          <div class="box-style-analytics mb-1">
            <p class="text-uppercase f-14">{{ $t('twitter.engagementRate')}}</p>
            <div class="d-flex align-items-center gap-2 mb-1" v-if="data.metrics.er.mark !== 'none'">
              <h2 class="m-0">{{ data.metrics.er.value.toFixed(2)}}%</h2>
              <b-badge class="badge-nivel" :style="`background-color: ${$t(`search_preview.engagement_nevel.${data.metrics.er.mark}`).color}`">
                {{ $t(`search_preview.engagement_nevel.${data.metrics.er.mark}`).text }}
              </b-badge>
            </div>
            <h2 v-else>N/D</h2>
            <p class="avenir-medium" v-if="data.metrics.er.mark">
              <span v-if="data.metrics.er.mark === 'good' || data.metrics.er.mark === 'excellent'">{{ $t('search_preview.engagementbest') }} {{ data.metrics.er.prc_better }} %</span>
              {{ $t(`search_preview.engagement_nevel.${data.metrics.er.mark}`).long}}
            </p>
            <scale-rate-search v-if="data.metrics.er.mark && data.metrics.er.mark !== 'none'" :mark="data.metrics.er.mark"></scale-rate-search>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <!-- Estimed scoped for Instagram -->
          <div class="box-style-analytics mb-1">
            <div class="d-flex justify-content-between">
              <p class="text-uppercase f-14">{{ $t('search_preview.estimedReach') }}</p>
            </div>
        
            <!-- POST DATA -->
            <div class="d-flex mb-1 flex-wrap" v-if="!Array.isArray(data.features.blogger_reach)">
              <h2 class="m-0">{{ getFormat(data.features.blogger_reach.data.reach_from) }} - {{ getFormat(data.features.blogger_reach.data.reach_to) }}</h2>
              <b-badge class="badge-nivel" :style="`background-color: ${$t(`search_preview.engagement_nevel.${data.features.blogger_reach.data.reach_mark}`).color}`">{{ $t(`search_preview.engagement_nevel.${data.features.blogger_reach.data.reach_mark}`).text }}</b-badge>
              <p class="avenir-medium d-block w-100 mt-1">
                <span>{{ $t('search_preview.publish_seen') }} {{ data.calculated_metrics.prc_post_estimated_reach }} %</span>
                {{ $t(`search_preview.reach_estimed.${data.features.blogger_reach.data.reach_mark}`)}}
              </p>
            </div>
        
            <div v-else-if="Array.isArray(data.features.blogger_reach)" class="mb-1">
              <h2>N/D</h2>
              <p class="avenir-medium">{{ $t(`search_preview.reach_estimed.none`)}}</p>
            </div>
        
            <div class="grid-inner-box">
              <div class="inner-box">
                <p class="avenir-medium">{{ $t('search_preview.avgLikes') }}</p>
                <h4>{{ data.metrics.likes_avg.value ? getFormat(data.metrics.likes_avg.value) : $t('search_preview.notAvailable') }}</h4>
              </div>
              
              <div class="inner-box">
                <p class="avenir-medium">{{ $t('preview.avg_comments') }}</p>
                <h4>{{ data.metrics.comments_avg.value ? getFormat(data.metrics.comments_avg.value) : $t('search_preview.notAvailable') }}</h4>
              </div>
        
              <div class="inner-box">
                <p class="avenir-medium">{{ $t('search.averageViewsTiktok')}}</p>
                <h4>{{ data.metrics.short_video_views_avg.value ? getFormat(data.metrics.short_video_views_avg.value) : $t('search_preview.notAvailable') }}</h4>
              </div>
        
              <div class="inner-box">
                <p class="avenir-medium">{{ $t('search_preview.avgPost') }}</p>
                <div class="d-flex justify-content-between align-items-center">
                  <h4 class="m-0">{{ data.metrics.media_per_week.value ? getFormat(data.metrics.media_per_week.value) : $t('search_preview.notAvailable') }}</h4>
                  <b-badge :style="`background-color: ${$t(`search_preview.engagement_nevel.${data.metrics.media_per_week.mark}`).color}`">{{ $t(`search_preview.engagement_nevel.${data.metrics.media_per_week.mark}`).text }}</b-badge>
                </div>
              </div>            
            </div>
          </div>
        </b-col>
      </b-row>
    </b-col>

    <!-- Columna 2 -->
    <b-col cols="12" md="6">
      <b-row class="mb-2">
        <b-col class="py-2">
          <div class="grid-container mb-2" v-if="contents.length > 0">
            <div class="grid-item" v-for="(image, index) in contents" :key="index">
              <div class="img-cover" :style="{ backgroundImage: `url('${image.preview_url}')` }" @click="redirectPost(image.code, image.network)"></div>
              <div class="container-icon-heart">
                <p class="d-flex align-items-center" v-if="image.likes_count">
                  <feather-icon icon="HeartIcon" class="mr-05"></feather-icon>
                  <span>{{ getFormat(image.likes_count) }}</span>
                </p>
              </div>
            </div>
          </div>

          <!-- Grid analytics underneath images -->
          <div class="grid-analytics mb-2">
            <div v-for="(item, index) in analytics_data" :key="index" class="grid-item box-style-analytics">
              <span class="avenir-medium">{{ item.label }}</span>
              <span class="title-result">{{ item.value === 0 ? $t('search_preview.notAvailable') : item.value }}</span>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col >
          <!-- Box for categories and extra data -->
          <div class="box-style-analytics mb-2">
            <div class="d-flex justify-content-between align-items-center mb-1">
              <p class="f-14 m-0">
                <span class="text-uppercase text-blue text-underline cursor-pointer">@{{data.basic.username }}</span>
                · {{ getFormat(data.metrics.subscribers_count.value)}} <span class="text-uppercase"> {{ $t('campaigns.followers') }}</span>
              </p>
            </div>

            <h2>{{ data.basic.title }}</h2>
            <p class="avenir-medium border-bottom pb-1">{{ data.basic.description }}</p>

            <p class="text-uppercase f-14">{{ $t('search_preview.contentCategory') }}</p>

            <div class="grid-categories">
              <div v-for="(category, index) in userCategories()" :key="index" class="avenir-medium d-flex flex-column align-items-center text-center">
                <b-img :src="getIconInterest(category)" class="img-grid-categorie" v-if="getIconInterest(category)"></b-img>
                <b-icon :icon="getCategoryIconSearcher(category)" v-else class="icon-b"></b-icon>
                <span class="mt-1 d-block">
                  {{ $te(`instagram.${category}`) ? $t(`instagram.${category}`) : category }}
                </span>
              </div>
            </div>
            
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="card-resumen p-1 mb-1">
            <div class="icon-aling">
              <b-img :src="require(`@/assets/images/icons/stars.svg`)" class="icon-stars"></b-img>
            </div>
            <div>
              <span class="text-gray f-16">{{ $t(`search_preview.titleCard`)}}</span>
              <p class="text-gray avenir-medium mb-0"> 
                {{ $t(`search_preview.textCard`)}}
              </p>
            </div>
          </div>

        </b-col>
      </b-row>  
    </b-col>
    <b-col cols="12" v-if="!printing && !is_web" class="text-right">
      <b-button
        variant="primary"
        class="hide-sm"
        @click="print()"
      >
        {{$t('printSummary')}}
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, 
  BCol,
  BAvatar,
  BImg,
  BBadge,
  BButton,
  BIcon,
} from 'bootstrap-vue'
import { getFormat, urlImagetoBase64, getFormattedDateTime } from "@/libs/utils/formats";
import { getCategoryIconSearcher, getIconInterest, getIconWhitePng, getIconColor } from "@/libs/utils/icons";
import { print, getMotivationalPhrase } from '@/libs/utils/others';
import service from '@/services/search';
import { getUserData } from '@/libs/utils/user';

export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    avatar: {
      type: String,
      default: () => ''
    },
    format: {
      type: String,
      default: 'pdf'
    },
    is_web: {
      type: Boolean,
      default: false
    }
  },
  components: {
    BRow,
    BCol,
    BAvatar,
    BImg,
    BBadge,
    BButton,
    BIcon,
    scaleRateSearch: () => import('@/views/components/graph/scaleRateSearch.vue'),
  },
  data () {
    return {
      urlImagetoBase64,
      getIconWhitePng,
      getIconColor,
      getMotivationalPhrase,
      getFormat,
      getCategoryIconSearcher,
      getIconInterest,
      categories: [],
      printing: false,
      interval_loading: null,
      contents: []
    }
  },
  created() {
    this.getCategories();
    this.getImagesBase64()

    if (!this.is_web) {
      this.$nextTick(() => {
        setTimeout(() => {
          this.print();
        }, 10);
      });
    }
  },
  computed: {
    is_personalized_service() {
      return getUserData() && getUserData().main_group.name === 'espejo'
    },
    analytics_data() {
      const data = [
        {
          label: 'ER',
          value: this.data.metrics.er?.value ? `${this.data.metrics.er.value.toFixed(2)} %` : 'N/A'
        },
        {
          label: this.$t('search_preview.avgLikes'),
          value: this.data.metrics.likes_avg?.value ? getFormat(this.data.metrics.likes_avg.value) : this.$t('search_preview.notAvailable')
        },
        {
          label: this.$t('search_preview.reach'),
          value: this.data.features.blogger_reach?.data?.reach ? getFormat(this.data.features.blogger_reach.data.reach) : this.$t('search_preview.notAvailable')
        },
        {
          key: 'price',
          label: this.$t('search_preview.estimedPrice'),
          value: this.data.features.blogger_prices?.data?.post_price ? `$${getFormat(this.data.features.blogger_prices.data.post_price)}` : this.$t('search_preview.notAvailable')
        }
      ];
      return this.is_personalized_service ? data.filter(item => item.key !== 'price') : data;
    },
  },
  methods: {
    print() {
      this.printing = true;
      const self = this;
      const username = this.$route.params.alias ? this.$route.params.alias : this.data.basic.title
      this.$emit('toogleIconClose', true)
      const name_file = `BrandMe Resumen Metricas ${username} Instagram ${getFormattedDateTime()}`
      this.$vs.loading({
        type: 'sound',
        background: 'rgba(255, 255, 255, 1)',
        text: getMotivationalPhrase(),
      });

      this.interval_loading = setInterval(() => {
        const prev_loading = document.getElementsByClassName('con-vs-loading')[0]

        if (prev_loading) {
          prev_loading.classList.add('fade-out');
          setTimeout(function() {
            prev_loading.remove()
          }, 500);

          this.$vs.loading({
            type: 'sound',
            background: 'rgba(255, 255, 255, 1)',
            text: getMotivationalPhrase(),
          });
        }
      }, 5000);
      setTimeout(function() {
        print('l', name_file, self.$parent.$parent.$refs.body, function () {
          self.printing = false;
          clearInterval(self.interval_loading)
          self.$vs.loading.close()
          self.$emit('toogleIconClose', false)
          self.$emit('closeModal')
        }, self.format)
      }, 500);
    },
    getCategories() {
      service.getCategories('instagram')
        .then(response => {
          const labels = response.labels || [];

          this.categories = labels.map(cat => ({
            id: cat.id,
            title: cat.title
          }));
        })
        .catch(() => {
          console.error('Error al cargar categorías');
        });
    },

    userCategories() {
      const IDs = this.data.features?.blogger_labels?.data || [];

      const titles = [];

      IDs.forEach(id => {
        const exists = this.categories.find(cat => cat.id === id);
        if (exists) {
          titles.push(exists.title);
        }
      });

      return titles.slice(0, 6);
    },
    getImagesBase64() {
      const images = this.getImagesContent();
      if (!this.is_web) {
        const promises = images.map(image => {
          return new Promise(resolve => {
            this.urlImagetoBase64(image.preview_url, base64 => {
              resolve({ ...image, preview_url: base64 });
            });
          });
        });

        Promise.all(promises).then(base64Images => {
          this.contents = base64Images;
        });
      } else {
        this.contents = images;
      }
    },
    getImagesContent() {
      if (this.data.features.last_media?.data && Object.keys(this.data.features.last_media.data).length > 0) {
        const array_images = []
        for (const image_objet in this.data.features.last_media.data) {
          array_images.push({
            preview_url: this.data.features.last_media.data[image_objet].basic.preview_url,
            likes_count: this.data.features.last_media.data[image_objet].metrics.likes_count,
            code: this.data.features.last_media.data[image_objet].basic.code,
            network: this.data.features.last_media.data[image_objet].basic.social_type
          })
        }
        return array_images.slice(0, 5);
      }
      return []
    },
  }
}
</script>

<style scoped lang="scss">
.f-16 {
  font-size: 16px;
}
.icon-stars {
  width: 20px;
  height: 20px;
}
.icon-aling {
  align-content: space-around;
}
.card-resumen {
  background-color: rgba(65, 137, 230, .15);
  border-radius: 6px;
  display: flex;
  padding: 20px;
  border: 1px solid #E2E8F0;
  box-shadow: 0 1px 4px #0b14260a;
  gap:16px
}
.icon-network {
  position: relative;
  width: 38px !important;
  height: 38px !important;
  left: 55px;
  bottom: 35px;
}
.grid-container {
  display: grid;
  cursor:pointer;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;

  .grid-item {
    .container-icon-heart {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 45%;
      background: linear-gradient(180deg,rgba(0,0,0,0) 0,rgba(0,0,0,.8) 100%);
      border-bottom-right-radius: 6px;
      border-bottom-left-radius: 6px;
      display: flex;
      align-items: end;
      p {
        margin-left: 1em;
        color: white;
        font-family: 'avenir-medium';
        overflow: hidden;
      }
    }
    background-color: white;
    position: relative;
    .img-cover {
      width: 100%;
      height: 135.5px;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    }
    &:nth-child(1) {
      grid-column-start:1;
      grid-column-end: 3;
      grid-row-start: 1;
      grid-row-end: 3;
      
      .img-cover {
        border-top-left-radius: 6px;
        border-bottom-left-radius: 6px;
        height: 281px;
      }
    }
    &:nth-child(3) {
      .img-cover {
        border-top-right-radius: 6px;
      }
    }
    &:nth-child(5) {
      .img-cover {
        border-bottom-right-radius: 6px;
      }
    }
  }
}
.f-14 {
  font-size: 14px;
}
.grid-analytics {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;

  @media (max-width: 700px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 400px) {
    grid-template-columns: repeat(1, 1fr);
  }

  .title-result {
    font-size: 20px;
    width: 100%;
    display: block;
  }
}
  .w-full {
    width: 100%;
  }
  .no-shadow {
    box-shadow: none;
  }
  .border-bottom-sidebar {
    position: relative;
    height: fit-content;
    top: 15px;
  }
  .text-muted-left-side-analytics {
    font-size: 16px;
    font-family: 'avenir-medium';
    color: #718096;
    margin-bottom: 0.3em;
  }
  .img-bm {
    width: 100%;
    height: auto;
    max-width: 200px;
  }
  
.box-style-analytics {
  border-radius: 6px;
  box-shadow: 0 1px 4px #0b14260a;
  padding: 16px;
  background-color: white;
  border: 1px solid #E2E8F0;
  .grid-inner-box {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 10px;
  @media (max-width: 500px) {
    grid-template-columns: repeat(1, 1fr);
  }
    .inner-box {
      border: 1px solid #E2E8F0;
      border-radius: 6px;
      box-shadow: 0 1px 4px #0b14260a;
      padding: 16px;
    }
  }
  .grid-categories {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 10px;

    @media (max-width: 600px) {
      grid-template-columns: repeat(auto-fit, minmax(70px, 1fr)); 
    }
    .img-grid-categorie {
      width: 24px;
      height: 24px;
    }
    .icon-b {
      width: 24px;
      height: 24px;
    }
  }
  .grid-more-info {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(4);
    gap: 10px;

  }
}
.badge-nivel {
  font-family: 'avenir-medium' !important;
  font-size: 14px;
  margin-left: 0.5em;
  line-height: 1.3;
  font-weight: 500;
}
</style>
